import styled from 'styled-components';
import { colors, getSpacing } from '../utils';

export const CardHeader = styled.div`
  align-items: ${props => props.align};
  border-bottom-width: 0;
  border-color: ${props => (props.borderColor ? props.borderColor : '#ddd')};
  display: flex;
  flex-direction: ${props => props.flexDirection || 'row'};
  justify-content: ${props => props.justify};
  margin: ${props => (props.margin ? getSpacing(props.margin) : 0)};
  padding: ${props => (props.padding ? getSpacing(props.padding) : 0)};
  width: 100%;
`;

export const CardBody = styled.div`
  align-items: ${props => props.align};
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justify};
  margin: ${props => getSpacing(props.margin)};
  padding: ${props => getSpacing(props.padding)};
`;

CardBody.defaultProps = {
  margin: 'none',
  padding: 'none'
};

export const Card = styled.div`
  align-items: ${props => props.align};
  background-color: ${props => props.backgroundColor};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: ${props => props.justify};
  margin: ${props => getSpacing(props.margin)};
  margin-top: 60px;
  margin-bottom: 24px;
  padding: 40px 16px;
  position: relative;
  width: 610px;
`;

Card.defaultProps = {
  align: 'center',
  backgroundColor: 'white',
  margin: 'auto'
};

export const Line = styled.hr`
  background-color: ${colors.g01};
  border: 0;
  height: 4px;
  margin: 10px 0;
  padding: 0 16px;
  width: 100%;
`;
